import { GlobalStore, UserStore } from '@roc/feature-app-core';
import { yesNoOptions } from '@roc/ui'
import { ApiResponse } from '@roc/feature-app-core';
import { action, computed, flow, makeObservable, observable } from 'mobx';
import { LoanEconomicsFormStore } from './loanEconomicsFormStore';
import { BorrowerLoanSubmissionService } from '../../../services/borrowerLoanSubmissionService';
import { SinglePropertyBorrowerInformationStore } from '../../singleProperty/singlePropertyBorrowerInformationStore';
import { SinglePropertyPropertyStore } from '../../borrowerLoanSubmission/propertyInformation/singlePropertyStore';
import { CONDOMINIUM, DUPLEX, LoanSubType, PPP_0_NO_PREPAY, PPP_1_0_0, PPP_5_4_3_2_1, PURCHASE, REFINANCE, SINGLE_FAMILY, TOWNHOME, isNil, isNumber, prePaymentPenaltyOptions0To1Prepay, prePaymentPenaltyOptionsNoPrepayOnly, prePaymentPenaltyOptionsSingleProperty } from '@roc/feature-utils';
import { RateScenario } from '@roc/feature-types';
export const BASE_RATES = 'baseRates';
export const MAX_RATES = 'maxRates';
export const RATES = 'yieldSpreadPremiumRates';
export const FULLY_AMORTIZING = 'fullyAmortizing';
export const MIXED_USE = 'Mixed Use';
export const MULTIFAMILY_5_PLUS = '5Plus Unit Multifamily';
export const FIVE_YEAR_US_TREASURY = 5001;
export const TEN_YEAR_US_TREASURY = 5002;
export const getUnitsByPropertyType = value => {

  switch (value) {
    case 'Single Family':
    case 'Townhome':
    case 'Planned Unit Development':
    case 'Condominium':
      return 1;
    case 'Duplex':
      return 2;
    case 'Triplex':
      return 3;
    case 'Quadruplex':
      return 4;
    case MULTIFAMILY_5_PLUS:
      return 5;
    case MIXED_USE:
      return 2;
    default:
      return 0;
  }
};
export const FULLY_AMORTIZING_LABEL = 'Fully Amortizing';
export const ltvMapper = {
  5: '0-5',
  10: '6-10',
  15: '11-15',
  20: '16-20',
  25: '21-25',
  30: '26-30',
  35: '31-35',
  40: '36-40',
  45: '41-45',
  50: '46-50',
  55: '50-55',
  60: '55-60',
  65: '61-65',
  70: '66-70',
  75: '71-75',
  80: '76-80',
  85: '81-85',
};
const mapValueToLtv = loanToValue => {
  switch (loanToValue) {
    case 5:
      return '0-5';
    case 10:
      return '6-10';
    case 15:
      return '11-15';
    case 20:
      return '16-20';
    case 25:
      return '21-25';
    case 30:
      return '26-30';
    case 35:
      return '31-35';
    case 40:
      return '36-40';
    case 45:
      return '41-45';
    case 50:
      return '46-50';
    case 55:
      return '50-55';
    case 60:
      return '55-60';
    case 65:
      return '61-65';
    case 70:
      return '66-70';
    case 75:
      return '71-75';
    case 80:
      return '76-80';
    case 85:
      return '81-85';
  }
};
export const RATE_TERM_REFINANCE = 'Rate Term Refinance';
export const mapLoanPurpose = (propertyOwnership, seekingCashOut, anyDebt) => {
  if (!propertyOwnership) {
    return 'Purchase';
  } else if (propertyOwnership && anyDebt && !seekingCashOut) {
    return RATE_TERM_REFINANCE;
  } else {
    return 'Cash-Out Refinance';
  }
};

export const getAsIsValueByLoanPurpose = (loanPurpose, propertyValuation, acquisitionPrice) => {
  return loanPurpose == PURCHASE ? Math.min(propertyValuation, acquisitionPrice) : propertyValuation;
}

export class LoanEconomicsStore {
  loanEconomicsFormStore: LoanEconomicsFormStore;
  singlePropertyBorrowerInformationStore: SinglePropertyBorrowerInformationStore;
  singlePropertyPropertyStore: SinglePropertyPropertyStore;
  globalStore: any;
  loanAmount: number;
  private userStore: UserStore;
  borrowerSubmissionFees: any;
  selectedLtv: number;
  private loanSubmissionService: BorrowerLoanSubmissionService;
  ltv: number;
  rate: number;
  monthlyPIPayment: number;
  cashToClose: number;
  originationPointsAndFees: number;
  pitia: number;
  pitiaPayment: number;
  rateScenarios: any;
  quote: any;
  rateScenarioValidationErrors: any
  existValidationError: boolean;
  selectedQuotes: any[] = [];
  displayedQuotes: any[] = [];
  public prepaymentPenaltyOptions: any[] = prePaymentPenaltyOptionsNoPrepayOnly;

  constructor(globalStore: GlobalStore, userStore: UserStore, singlePropertyPropertyStore, singlePropertyBorrowerInformationStore) {
    this.loanEconomicsFormStore = new LoanEconomicsFormStore(globalStore);
    this.singlePropertyBorrowerInformationStore = singlePropertyBorrowerInformationStore;
    this.singlePropertyPropertyStore = singlePropertyPropertyStore;
    this.globalStore = globalStore;
    this.userStore = userStore;
    this.loanSubmissionService = new BorrowerLoanSubmissionService();
    this.rateScenarioValidationErrors;
    makeObservable(this, {
      rateScenarios: observable,
      quote: observable,
      fetchRatesAndLoanTermsV2: flow,
      fetchSfrPricerLoanTermsValuesV2: flow,
      fetchRatesAndLoanTermsForCustomQuote: flow,
      borrowerSubmissionFees: observable,
      fetchBorrowerSubmissionFees: flow,
      setRatesScenarios: flow,
      loanAmount: observable,
      selectedLtv: observable,
      setValidationErrors: flow,
      existValidationError: observable,
      rateScenarioValidationErrors: observable,
      selectedQuotes: observable,
      displayedQuotes: observable,
      toggleCustomQuote: action,
      clearSelectedQuotes: action,
      fetchRatesForCustomQuotes: flow,
      getYieldSpreadPremiumScenarios: flow,
      prepaymentPenaltyOptions: observable,
      getPrepayPenaltyOptions: flow,
    });
  }
  setLoanEconomics(data) {
    this.loanAmount = data.loanAmount;
    this.selectedLtv = data.defaultLTV;
  }
  calculateCashToClose(quote, fees) {
    const {
      annualTaxes,
      annualInsurance,
      outstandingLoanOnTheProperty,
      purchasePrice,
      propertyOwnership
    } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields
    const FIRST_3_MONTHS = 3;
    const YEAR_MONTHS = 12;
    const floor = {
      ZERO: 0,
      TWO_K: 200000,
      FIVE_K: 500000,
    }
    const percentages = {
      TIER_1: 0.04,
      TIER_2: 0.03,
      TIER_3: 0.02
    }
    const taxesCollectedAtClose = ((annualTaxes?.value ?? 0) / YEAR_MONTHS) * FIRST_3_MONTHS;
    const insuranceCollectedAtClose = ((annualInsurance?.value ?? 0) / YEAR_MONTHS) * FIRST_3_MONTHS;
    let thirdPartyCosts = 0;
    let deltaAmount = 0;
    if (propertyOwnership.value) {
      deltaAmount = Math.abs(quote?.pricerLoanTerms?.amount - (outstandingLoanOnTheProperty.value ?? 0));
    }
    else {
      deltaAmount = Math.abs(quote?.pricerLoanTerms?.amount - (purchasePrice.value ?? 0));
    }
    switch (quote?.pricerLoanTerms?.amount) {
      case quote?.pricerLoanTerms?.amount >= floor.ZERO && quote?.pricerLoanTerms?.amount <= floor.TWO_K:
        thirdPartyCosts = (percentages.TIER_1) * quote?.pricerLoanTerms?.amount
      case quote?.pricerLoanTerms?.amount > floor.TWO_K && quote?.pricerLoanTerms?.amount <= floor.FIVE_K:
        thirdPartyCosts = (percentages.TIER_2) * quote?.pricerLoanTerms?.amount
      default:
        thirdPartyCosts = (percentages.TIER_3) * quote?.pricerLoanTerms?.amount
    }
    return (quote?.pricerLoanTerms?.monthlyPayment * FIRST_3_MONTHS) + taxesCollectedAtClose + insuranceCollectedAtClose + deltaAmount + thirdPartyCosts + (quote?.pointsAndFees ?? 0);
  }
  buildBuyDownRatesRequestData() {
    const {
      propertyType,
      currentMarketValue,
      purchasePrice,
      propertyOwnership,
      cashOut,
      outstandingLoanOnTheProperty,
    } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields;
    const loanPurpose = mapLoanPurpose(propertyOwnership.value, cashOut.value, outstandingLoanOnTheProperty.value);

    return {
      asIsValue: getAsIsValueByLoanPurpose(loanPurpose, currentMarketValue.value, purchasePrice.value),
      propertyType: propertyType.value,
      loanSubtype: LoanSubType.SINGLE_PROPERTY,
      noOfUnits: getUnitsByPropertyType(propertyType.value),
      propertyTypes: null,
    }
  }
  createSinglePropertyRequest() {
    const {
      prepenaltyPayment,
      rateType,
      amortization,
      loanToValue
    } = this.loanEconomicsFormStore?.form.fields;
    const userId = this.userStore.userInformation?.userId;
    const {
      propertyType,
      purchaseDate,
      zipCode,
      cashOut,
      section8,
      outstandingLoanOnTheProperty,
      monthlyMarketRent,
      state,
      county,
      propertyOwnership,
      purchasePrice,
      currentMarketValue,
      renoBudget,
    } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields
    const {
      rentalExperience,
      bankruptcyDate,
      foreclosureDate,
      citizenshipStatus,
      ficoProvidedAtOrigination
    } = this.singlePropertyBorrowerInformationStore.mainBorrowerFormStore?.form.fields;

    const formattedDate =
      purchaseDate.value && new Date(purchaseDate.value);
    const formattedBankruptcyDate =
      bankruptcyDate?.value && new Date(bankruptcyDate?.value);
    const formattedForeclosureDate =
      foreclosureDate?.value && new Date(foreclosureDate?.value);
    const borrowerExpMapping = {
      '0': '0',
      '1': '1-2',
      '2': '3-4',
      '3': '5-9',
      '4': '10-49',
      '5': '50+',
    };
    const loanPurpose = mapLoanPurpose(propertyOwnership.value, cashOut.value, outstandingLoanOnTheProperty.value);

    return {
      paymentChoice: 'sharePoints',
      chargeBorrower: "yieldSpreadPremiumRates",
      loanTerm: 30,
      propertyType: propertyType.value,
      asIsValue: getAsIsValueByLoanPurpose(loanPurpose, currentMarketValue.value, purchasePrice.value),
      monthlyRent: monthlyMarketRent.value,
      loanPurpose: loanPurpose,
      purchasePrice: purchasePrice.value,
      purchaseDate: formattedDate ? formattedDate.toISOString() : null,
      capitalImprovements: renoBudget.value ?? 0,
      creditScore: ficoProvidedAtOrigination.value,
      borrowerExp: borrowerExpMapping[rentalExperience.value],
      foreignNationalFlag: citizenshipStatus.value,
      rateType: rateType.value,
      prePaymentPenalty: prepenaltyPayment.value,
      loanSubtype: LoanSubType.SINGLE_PROPERTY,
      numberOfUnits: getUnitsByPropertyType(propertyType.value),
      commercialUnits: 0,
      residentialUnits: 0,
      commercialArea: 0,
      residentialArea: 0,
      commercialIncome: 0,
      residentialIncome: 0,
      bankruptcyDate: formattedBankruptcyDate,
      foreclosureDate: formattedForeclosureDate,
      state: state.value,
      propertyCounties: [county.value],
      commercialUnitsCurrentOnRent: 0,
      userId: userId,
      currentBuydown: 0,
      buydownFee: 0,
      loanToValue: loanToValue.value,
      amortization: amortization.value,
      zipCode: zipCode.value,
      hasSection8: section8.value,
      isRuralFromOriginator: false,// check this
      anyDebt: outstandingLoanOnTheProperty.value,
    };
  }

  *fetchBorrowerSubmissionFees() {
    try {
      const response: ApiResponse = yield this.loanSubmissionService.getBorrowerSubmissionFees();
      const totalAddOnFee = (response?.data?.adminFees ?? 0)
        + (response?.data?.commitmentFees ?? 0)
        + (response?.data?.processingFees ?? 0)
        + (response?.data?.underwriterFees ?? 0)
        + (response?.data?.buydownFees ?? 0);
      this.borrowerSubmissionFees = { ...response.data, totalAddOnFee };
    }
    catch (error) {
      console.log('Error setting rates', error);
      this.borrowerSubmissionFees = [];
    }
  }

  *fetchRatesAndLoanTermsV2() {
    try {
      const userId = this.userStore.userInformation?.userId;
      const {
        rateType,
        amortization,
        loanToValue,
      } = this.loanEconomicsFormStore.form.fields;
      this.fetchBorrowerSubmissionFees();
      const ratesRequest = {
        ...this.createSinglePropertyRequest(),
        ...this.singlePropertyExpense(),
      }
      const underwritingProcessingFees = {
        underwritingProcessingFees: [],
        buydownPoints: 0
      };
      const request = {
        sfrFormData: {
          ...ratesRequest,
          userId: userId,
          isBroker: false,
          currentBuydown: 0,
          buydownPoints: 0,
          ...underwritingProcessingFees,
        },
        buydownRequestData: this.buildBuyDownRatesRequestData(),
      };
      yield this.getPrepayPenaltyOptions(ratesRequest);
      const response: ApiResponse = yield this.loanSubmissionService.getRatesScenarios(request);

      this.setRatesScenarios(response.data, request.sfrFormData);

      const ltvRange = ltvMapper[loanToValue.value];
      let rateResults = [];
      const buydowns = Object.keys(response.data.scenarios).map(buydown => buydown);
      for (let key of buydowns) {
        rateResults.push(response.data.scenarios[key].ltvRates[rateType.value][amortization.value]?.baseRates[ltvRange]);
      };

      let selectedLtvRatesForValidation = {};
      for (let key of buydowns) {
        const parsedBuydown = Number(key);
        selectedLtvRatesForValidation[parsedBuydown] = response.data.scenarios[key].ltvRates[rateType.value][amortization.value]?.baseRates[ltvRange];
      };
      const errorValidationRequest = {
        sfrFormData: {
          ...request.sfrFormData,
          loanToValue: loanToValue.value,
        },
        selectedLtvRates: selectedLtvRatesForValidation,
      }
      const validationErrorResponse: ApiResponse = yield this.loanSubmissionService.getRateValidationErrors(errorValidationRequest);
      console.log({ validationErrorResponse })
      this.setValidationErrors(validationErrorResponse.data);
    } catch (error) {
      console.log('Error setting rates', error);
      this.rateScenarios = [];
    }
  }
  *setValidationErrors(data: any) {
    if (Object.keys(data).length > 0) {
      this.existValidationError = true;
      this.rateScenarioValidationErrors = Object.values(data)[0];
    }
    else {
      this.existValidationError = false;
      this.rateScenarioValidationErrors = ''
    }
  }

  setSelectedQuotes(newQuote) {
    let quoteIndex = this.displayedQuotes.find(
      (q) => q.buydownKey === newQuote.buydownKey
    );
    if (!quoteIndex) {
      this.displayedQuotes.push(newQuote);
      quoteIndex = this.displayedQuotes.length - 1;
    }
    this.fetchRatesAndLoanTermsForCustomQuote(newQuote, quoteIndex);
  }

  *setRatesScenarios(data: any, sfrFormData: any) {
    const buydowns = Object.keys(data.scenarios).map(buydown => buydown).sort((a, b) => (Number(b) - Number(a)));
    const {
      rateType,
      amortization,
      prepenaltyPayment,
    } = this.loanEconomicsFormStore.form.fields;
    const {
      currentMarketValue,
      purchasePrice,
      propertyOwnership,
      cashOut,
      outstandingLoanOnTheProperty,
    } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields;

    const loanPurpose = mapLoanPurpose(propertyOwnership.value, cashOut.value, outstandingLoanOnTheProperty.value);
    const asIsValue = getAsIsValueByLoanPurpose(loanPurpose, currentMarketValue.value, purchasePrice.value);
    let maxFees = 0;
    let youMakeForBroker = 0;
    let youMakeForBrokerPercent = 0;
    let loanToValue = this.loanEconomicsFormStore.form.fields.loanToValue.value;

    let checkDone = false;
    while (!checkDone && loanToValue > 0) {
      const ltvRange = ltvMapper[loanToValue];
      if (ltvRange || loanToValue >= 80) {
        checkDone = true;
        this.loanEconomicsFormStore.onFieldChange('loanToValue', loanToValue);
      } else {
        loanToValue += 1;
      }
    }

    this.loanAmount = asIsValue * (loanToValue / 100);

    let rates = [];

    // Using normal for-loop to avoid yield operator problems
    for (let i = 0; i < buydowns.length; i++) {
      const buydown = buydowns[i];
      const scenario = data.scenarios[buydown];
      const parsedBuydown = Number(buydown);
      const amortizationData = scenario.ltvRates[rateType.value][amortization.value];
      const ltvRange = ltvMapper[loanToValue];
      const rateObj = amortizationData.baseRates[ltvRange];
      const rate = rateObj && rateObj?.errorMessage.length === 0 ? this.calculateRate(rateObj) : null;
      const maxRate = rate ? this.calculateMaxRate(rateObj.swapRate, amortizationData.maxRates[ltvRange]) : 0;
      const pointsAndFees = Math.round((this.loanAmount * (parsedBuydown / 100)) * 100) / 100;

      const rateScenario: RateScenario = {
        fullScenario: scenario,
        buydownKey: buydown,
        buydown: parsedBuydown,
        amortizationData,
        amortization: amortization.value,
        loanToValue: loanToValue,
        prePaymentPenalty: prepenaltyPayment.value,
        rateType: rateType.value,
        rate,
        baseRate: rateObj,
        pointsAndFees,
        pointsAndFeesPercent: parsedBuydown,
        pricerLoanTerms: {
          loanTerms: scenario.ltvRates,
          allInvestorRates: scenario.allInvestorRates,
          maxYspBasedonAmortizationType: scenario.maxYspBasedonAmortizationType,
          maxYsp: scenario.maxYspBasedonAmortizationType[amortization],
          overRideRates: scenario.overRideRatesBasedonAmortizationType,
        },
        commissions: {},
        minRate: rate,
        maxRate,
        yieldSpread: 0,
        maxYieldSpread: scenario.maxYspBasedonAmortizationType[amortization.value],
        maxPointsAndFees: pointsAndFees,
        youMakeForWholesale: 0,
        youMakeForWholesalePercent: 0,
        originationPointsRetail: 0,
        originationPointsRetailAmount: 0,
        originationPointsRoc: 0,
        youMakeForBroker,
        youMakeForBrokerPercent,
        validationError: '',
      };
      // max buydown scenario
      if (i === 0) {
        maxFees = pointsAndFees;
      }

      if (!isNil(rateScenario.rate)) {
        const pricerLoanTerms = yield this.fetchSfrPricerLoanTermsValuesV2(rateScenario, 0);

        rateScenario.pricerLoanTerms = {
          ...rateScenario.pricerLoanTerms,
          ...pricerLoanTerms
        };
      }
      rates.push(rateScenario);
    }

    const quoteList = rates.map((rate) => {
      return {
        ...rate,
        compare: false,
        fees: {},
        feesRows: [],
        totalAllocatedFees: 0,
        totalNonRocFees: 0,
      };
    });
    const yieldScenarios = yield this.getYieldSpreadPremiumScenarios(quoteList, sfrFormData);
    if (yieldScenarios.length > 0) {
      rates = yieldScenarios;
    }

    this.rateScenarios = rates.map(rate => ({ ...rate, maxPointsAndFees: maxFees }));
  }

  *getYieldSpreadPremiumScenarios(quoteList: any, sfrFormData: any) {
    const request = {};
    const yieldSpread = this.borrowerSubmissionFees.yieldSpreadPremium ?? 0;
    const yieldSpreadQuotes = [];

    if (yieldSpread > 0) {
      for (let index = 0; index < quoteList.length; index++) {
        const customQuote = quoteList[index];
        const { amortization, loanToValue, fullScenario, prePaymentPenalty, rateType, loanPurpose, maxYieldSpread, pointsAndFees } = customQuote;

        const data = {
          rates: fullScenario.ltvRates,
          standardRates: null,
          yieldSpread: yieldSpread > maxYieldSpread ? maxYieldSpread : Number(yieldSpread.toFixed(4)),
          loanSubtype: sfrFormData.loanSubtype,
          loanTerm: sfrFormData.loanTerm,
          rateType: rateType,
          propertyType: sfrFormData.propertyType,
          userId: sfrFormData.userId,
          numberOfProperties: 1,
          noOfUnits: sfrFormData.numberOfUnits,
          asIsValue: sfrFormData.asIsValue,
          allInvestorRates: fullScenario.allInvestorRates,
          allInvestorStandardRates: null,
          isBroker: false,
          monthlyRent: sfrFormData.monthlyRent,
          grossAnnualTaxes: sfrFormData.annualTaxes,
          grossAnnualInsurance: sfrFormData.annualInsurance,
          annualHOADues: sfrFormData.annualHoa,
          currentBuydown: 0,
          buydownPoints: 0,
          loanToValue: loanToValue,
          amortization: amortization,
          prePaymentPenalty: prePaymentPenalty,
          loanPurpose,
          underwritingProcessingFees: [pointsAndFees ?? 0],
        };
        request[customQuote.buydown] = data;
      }

      const response: ApiResponse = yield this.loanSubmissionService.getYieldSpreadPremiumScenarios({ scenarios: request });

      const yieldScenarios = response.data.scenarios;
      const buydowns = Object.keys(yieldScenarios).map(buydown => buydown).sort((a, b) => (Number(b) - Number(a)));
      for (let i = 0; i < buydowns.length; i++) {
        const buydown = buydowns[i];
        const yieldScenario = yieldScenarios[buydown];
        const matchingQuoteFromList = quoteList.find((quote) => quote.buydown === Number(buydown));
        const { amortization, loanToValue, rateType } = matchingQuoteFromList;
        const amortizationData = yieldScenario.rates[rateType][amortization];
        const ltvRange = ltvMapper[loanToValue];
        const rateObj = amortizationData.baseRates[ltvRange];
        const newRate = rateObj.errorMessage.length === 0 ? this.calculateRate(rateObj) : null;

        const newQuote = {
          ...matchingQuoteFromList,
          rate: newRate,
          amortizationData,
          pricerLoanTerms: {
            ...matchingQuoteFromList.pricerLoanTerms,
            loanTerms: yieldScenario.rates,
          },
        }

        if (!isNil(newQuote.rate)) {
          const newLoanTerms = yield this.fetchSfrPricerLoanTermsValuesV2(newQuote, matchingQuoteFromList.yieldSpread);

          newQuote.pricerLoanTerms = {
            ...newQuote.pricerLoanTerms,
            ...newLoanTerms,
          };
        }
        yieldSpreadQuotes.push(newQuote);
      }
      const listOfNewRates = yieldSpreadQuotes.map(quote => quote.rate);
      const maxRate = Math.max(...listOfNewRates);
      yieldSpreadQuotes.map(quote => {
        quote.maxRate = maxRate;
        quote.minRate = quote.rate;
      });
    }
    return yieldSpreadQuotes;
  }

  getSfrPricerLoanTermsRequestBodyV2(rateScenario: RateScenario, oneTimeYieldSpreadPremium: number) {
    const {
      rate: rateChargedToBorrower,
      loanToValue,
      rateType,
      amortization,
      prePaymentPenalty,
    } = rateScenario;
    const paymentChoice = 'sharePoints';
    const {
      propertyType,
      purchaseDate,
      cashOut,
      outstandingLoanOnTheProperty,
      propertyOwnership,
      purchasePrice,
      currentMarketValue,
      renoBudget,
    } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields
    const selectedLtvRate = rateScenario.pricerLoanTerms?.loanTerms?.[rateType]?.[amortization]?.baseRates[ltvMapper[rateScenario.loanToValue]];

    let ratesForSelectedLtv = rateScenario.fullScenario.allInvestorRates[rateType][amortization];
    ratesForSelectedLtv = ratesForSelectedLtv.map(
      rate => rate?.baseRates?.[mapValueToLtv(loanToValue)]
    );
    const loanPurpose = mapLoanPurpose(propertyOwnership.value, cashOut.value, outstandingLoanOnTheProperty.value);
    const asIsValue = getAsIsValueByLoanPurpose(loanPurpose, currentMarketValue.value, purchasePrice.value);;
    const formattedDate = purchaseDate && new Date(purchaseDate.value);

    const requestBody = {
      ltvBand: mapValueToLtv(loanToValue),
      asIsValue: asIsValue,
      finalRate: rateChargedToBorrower,
      loanToValue: loanToValue,
      selectedLtvRate,
      ratesForSelectedLtv,
      amortization: amortization,
      rateTermType:
        amortization === FULLY_AMORTIZING
          ? `${rateType} ${FULLY_AMORTIZING_LABEL}`
          : rateType,
      typeOfRate:
        oneTimeYieldSpreadPremium === 0
          ? BASE_RATES
          : MAX_RATES,
      yieldSpreadPremium: oneTimeYieldSpreadPremium,
      loanPurpose: loanPurpose,
      purchasePrice: purchasePrice.value,
      paymentChoice,
      prePaymentPenalty: prePaymentPenalty,
      loanSubtype: LoanSubType.SINGLE_PROPERTY,
      loanTerm: 30,
      numberOfUnits: getUnitsByPropertyType(propertyType.value),
      residentialUnits: 0,
      commercialUnits: 0,
      totalMixUseEstimatedAsIsValue: 0,
      userId: this.userStore.userInformation?.userId,
      sfrProperty: null,
      numberOfProperties: null,
      rateBuydown: 0, //check
      purchaseDate: formattedDate ? formattedDate.toISOString() : null,
      capitalImprovements: renoBudget.value,
    };

    return {
      ...requestBody,
      propertyType: propertyType.value,
      ...this.singlePropertyExpense(),
    };
  }

  singlePropertyExpense() {
    const {
      annualTaxes,
      annualInsurance,
      annualHOA,
      monthlyMarketRent,
      propertyType,
      currentlyOccupied,
      loanPurpose,

    } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields;
    return {
      grossAnnualTaxes: annualTaxes.value,
      grossAnnualInsurance: annualInsurance.value,
      annualHoaDues: annualHOA.value,
      numberOfUnits: getUnitsByPropertyType(propertyType.value),
      monthlyRent: monthlyMarketRent.value,
      generalAdministrative: 0,
      payroll: 0,
      marketing: 0,
      replacementReserves: 0,
      totalAnnualUtilities: 0,
      totalAnnualRepairsMaintenance: 0,
      totalAnnualPropertyManagementFees: 0,
      totalAnnualExpenses: (Number(annualTaxes.value) ?? 0) + (Number(annualInsurance.value) ?? 0) + (Number(annualHOA.value) ?? 0)
    };
  };

  *fetchSfrPricerLoanTermsValuesV2(rateScenario: RateScenario, oneTimeYieldSpreadPremium: number) {
    const rateChargedToBorrower = rateScenario.rate;

    try {
      const requestBody = this.getSfrPricerLoanTermsRequestBodyV2(rateScenario, oneTimeYieldSpreadPremium);
      const underwritingProcessingFees = {
        underwritingProcessingFees: [(rateScenario?.pointsAndFeesPercent * (rateScenario?.pricerLoanTerms.amount)) / 100],
        buydownPoints: 0
      };
      const response: ApiResponse = yield this.loanSubmissionService.postPricerLoanTerms(
        {
          ...requestBody,
          currentBuydown: 0,
          buydownPoints: 0,
          ...underwritingProcessingFees,
          isBroker: false,
        }
      );

      const {
        loanAmount,
        monthlyPayment,
        monthlyPaymentWithoutExpenses,
        totalPremium,
        lenderPremium,
        yieldSpreadPremiumAmount,
        minRocPoints,
        boxes,
        investorSalePrices,
        selectedLtvRate,
        submissionInvestor,
        loanTerm,
      } = response.data;

      const {
        purchasePrice,
        propertyOwnership,
        cashOut,
        outstandingLoanOnTheProperty,
      } = this.singlePropertyPropertyStore.propertyFormStore.form.fields;

      const rate = rateScenario.pricerLoanTerms?.loanTerms?.[rateScenario.rateType]?.[rateScenario.amortization]?.yieldSpreadPremiumRates[ltvMapper[rateScenario.loanToValue]];
      const loanPurpose = mapLoanPurpose(propertyOwnership.value, cashOut.value, outstandingLoanOnTheProperty.value);

      const loanTerms = {
        // ...this.pricerLoanTerms,
        ...{
          amount: loanAmount,
          loanPurpose: loanPurpose,
          acquisitionPrice: purchasePrice.value,
          totalDebtPayoff: outstandingLoanOnTheProperty.value,
          monthlyPayment: Number(monthlyPayment?.toFixed(3)), //TODO: Use util here
          monthlyPaymentWithoutExpenses: Number(monthlyPaymentWithoutExpenses?.toFixed(3)),
          rateChargedToBorrower,
          swapRate: rate.swapRate,
          spreadRate: rate.spreadRate,
          totalPremium,
          lenderPremium,
          outOfBox: false,
          oneTimeYieldSpreadPremiumAmount: yieldSpreadPremiumAmount,
          investorId: rate?.investorId,
          minRocPoints: minRocPoints,
          boxes: boxes,
          investorSalePrices: investorSalePrices,
          selectedLtvRate,
          submissionInvestor,
          loanTerm,
        },
      };

      return loanTerms;
    } catch (error) {
      console.log('error', error)
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while fetching loan terms.',
      });
    }
  }
  calculateRate(data) {
    return Number((data.swapRate + data.spreadRate).toFixed(4));
  }

  calculateMaxRate(swapRate, data) {
    return Number((swapRate + data.spreadRate).toFixed(4));
  }
  setQuote(data) {
    this.selectedLtv = data.loanToValue;
    this.quote = data;
  }
  validateFields() {
    this.loanEconomicsFormStore.runFormValidation();
    return this.loanEconomicsFormStore.form.meta.isValid;
  }
  changeLTV(newLtv) {
    this.ltv = newLtv;
    this.fetchRatesAndLoanTermsV2();
  }
  changeSelectedLTV(newValue) {
    this.selectedLtv = newValue;
  }
  calculateIncomeAndExpenses() {
    const {
      currentMarketValue,
      monthlyMarketRent,
      annualTaxes,
      annualHOA,
      renoBudget,
      purchasePrice,
      annualInsurance,
      currentlyOccupied,
      propertyOwnership,
      cashOut,
      outstandingLoanOnTheProperty,
    } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields
    const calculatedExpenses = (Number(annualHOA?.value) ?? 0) + (Number(annualTaxes?.value) ?? 0) + (Number(annualInsurance?.value) ?? 0);
    const loanPurpose = mapLoanPurpose(propertyOwnership.value, cashOut.value, outstandingLoanOnTheProperty.value);
    const grossPotentialRent = monthlyMarketRent.value * 12;
    const calculatedIncome = grossPotentialRent;
    const calculatedOperatingIncome = calculatedIncome - calculatedExpenses;
    return {
      calculatedOperatingIncome,
      calculatedIncome,
      calculatedExpenses,
      grossPotentialRent
    }
  }

  *fetchRatesForCustomQuotes() {
    const quotesCopy = this.displayedQuotes.slice();

    // Using normal for-loop to avoid yield operator problems
    for (let index = 0; index < quotesCopy.length; index++) {
      const quote = {
        ...quotesCopy[index],
        amortization: this.loanEconomicsFormStore.form.fields.amortization.value,
        prepenaltyPayment: this.loanEconomicsFormStore.form.fields.prepenaltyPayment.value,
        rateType: this.loanEconomicsFormStore.form.fields.rateType.value,
      };
      yield this.fetchRatesAndLoanTermsForCustomQuote(quote, index);
    }
  }

  *fetchRatesAndLoanTermsForCustomQuote(customQuote, quoteIndex) {
    try {
      const userId = this.userStore?.userInformation?.userId;
      const {
        amortization,
        prepenaltyPayment,
        rateType,
      } = this.loanEconomicsFormStore.form.fields;
      const {
        loanToValue,
        rate,
        pricerLoanTerms,
        seekingCashOut,
        anyDebt,
        pointsAndFeesPercent
      } = customQuote;
      const yieldSpreadPremium = this.borrowerSubmissionFees?.yieldSpreadPremium ?? 0;
      const { paymentChoice, chargeBorrower, loanTerm } = pricerLoanTerms;

      const ratesRequest = {
        ...this.createSinglePropertyRequest(),
        ...this.singlePropertyExpense(),
      }
      const underwritingProcessingFees = {
        underwritingProcessingFees: [(pointsAndFeesPercent * pricerLoanTerms.amount) / 100],
        buydownPoints: 0
      };
      const {
        cashOut,
        outstandingLoanOnTheProperty,
        propertyType,
        propertyOwnership,
        currentMarketValue,
        monthlyMarketRent,
        annualTaxes,
        annualInsurance,
        annualHOA,
        purchasePrice,
      } = this.singlePropertyPropertyStore?.propertyFormStore.form.fields;
      const {
        rentalExperience,
        ficoProvidedAtOrigination
      } = this.singlePropertyBorrowerInformationStore.mainBorrowerFormStore?.form.fields;

      const loanPurpose = mapLoanPurpose(propertyOwnership.value, cashOut.value, outstandingLoanOnTheProperty.value);
      const request = {
        ...ratesRequest,
        userId: userId,
        isBroker: false,
        ...underwritingProcessingFees,
        paymentChoice,
        chargeBorrower,
        loanTerm: 30,
        rateType: rateType.value,
        oneTimeYieldSpreadPremium: yieldSpreadPremium,
        prePaymentPenalty: prepenaltyPayment.value,
        currentBuydown: 0,
        buydownPoints: 0,
        loanToValue,
        amortization: amortization.value,
        loanPurpose: loanPurpose,
        seekingCashOut,
        anyDebt: anyDebt == 'Y',
      };
      const response: ApiResponse = yield this.loanSubmissionService.getRatesSingleQuote(request);

      const asIsValue = getAsIsValueByLoanPurpose(loanPurpose, currentMarketValue.value, purchasePrice.value);
      let newLoanToValue = loanToValue;

      let checkDone = false;
      while (!checkDone && newLoanToValue > 0) {
        const scenario = response.data;
        const amortizationData = scenario.ltvRates[rateType.value][amortization.value];
        const ltvRange = ltvMapper[newLoanToValue];
        const rateObj = amortizationData.baseRates[ltvRange];
        const rate = rateObj && rateObj?.errorMessage.length === 0 ? 1 : null;
        if (rate) {
          checkDone = true;
        } else {
          newLoanToValue -= 5;
        }
      }
      while (!checkDone && newLoanToValue <= 80) {
        const scenario = response.data;
        const amortizationData = scenario.ltvRates[rateType.value][amortization.value];
        const ltvRange = ltvMapper[newLoanToValue];
        const rateObj = amortizationData.baseRates[ltvRange];
        const rate = rateObj && rateObj?.errorMessage.length === 0 ? 1 : null;
        if (rate) {
          checkDone = true;
        } else {
          newLoanToValue += 5;
        }
      }

      const loanAmount = asIsValue * (newLoanToValue / 100);
      const scenario = response.data;
      const amortizationData = scenario.ltvRates[rateType.value][amortization.value];
      const ltvRange = ltvMapper[newLoanToValue];
      const rateObj = amortizationData.baseRates[ltvRange];
      const newRate = rateObj.errorMessage.length === 0 ? this.calculateRate(rateObj) : null;
      const newMaxRate = newRate ? this.calculateMaxRate(rateObj.swapRate, amortizationData.maxRates[ltvRange]) : 0;
      const interestOnlyPeriod = amortization.value === FULLY_AMORTIZING ? 0 : 120;
      const fullyAmortizingPeriod = isNumber(interestOnlyPeriod) ? 360 - interestOnlyPeriod : 360;

      const dscrPayload = {
        loanSubtype: LoanSubType.SINGLE_PROPERTY,
        estimatedAsIsValue: getAsIsValueByLoanPurpose(loanPurpose, currentMarketValue.value, purchasePrice.value),
        requestedLTV: this.selectedLtv,
        rate: newRate,
        interestOnlyPeriod: interestOnlyPeriod,
        fullyAmortizingPeriod: fullyAmortizingPeriod,
        loanAmount: loanAmount,
        inPlaceMonthlyRent: monthlyMarketRent.value,
        monthlyMarketRent: monthlyMarketRent.value,
        annualQualifyingRent: this.calculateIncomeAndExpenses().grossPotentialRent,
        vacancy: null,
        vacancyPercentOfGPR: null,
        concession: null,
        concessionPercentOfGPR: null,
        creditLoss: null,
        creditLossPercentOfGPR: null,
        grossAnnualIncome: this.calculateIncomeAndExpenses().calculatedIncome,
        grossPotentialRent: this.calculateIncomeAndExpenses().grossPotentialRent,
        annualTaxes: annualTaxes.value,
        annualInsurance: annualInsurance.value,
        annualHOAFees: annualHOA.value,
        unitCount: getUnitsByPropertyType(propertyType.value),
        propertyManagementFee: null,
        propertyManagementFeePercentOfGPR: null,
        generalAndAdministrativeFee: null,
        generalAndAdministrativeFeePercentOfGPR: null,
        repairsAndMaintenance: null,
        repairsAndMaintenancePercentOfGPR: null,
        utilities: null,
        utilitiesPercentOfGPR: null,
        payroll: null,
        payrollPercentOfGPR: null,
        turnoverCosts: null,
        leasingAndMarketing: null,
        miscellaneous: null,
        totalOperatingExpensePercentOfGPR: null,
        replacementReserves: null,
        replacementReservesPercentOfGPR: null,
        requestedLtv: loanToValue,
      }
      const resp: ApiResponse = yield this.loanSubmissionService.getCalculatedValues(dscrPayload);
      const dscr = resp?.data?.data ?? {}
      const borrowerSubmissionFees = this.borrowerSubmissionFees ?? {};
      const fiveYrTsrySwap = scenario?.swapRates[FIVE_YEAR_US_TREASURY]
      const tenYrTsrySwap = scenario?.swapRates[TEN_YEAR_US_TREASURY]
      let newQuote = {
        ...customQuote,
        loanPurpose,
        rentalExperience: rentalExperience.value,
        ficoProvidedAtOrigination: ficoProvidedAtOrigination.value,
        fullScenario: scenario,
        loanToValue: newLoanToValue,
        amortizationData,
        rate: newRate,
        minRate: newRate,
        baseRate: newRate,
        maxRate: newMaxRate,
        dscr,
        borrowerSubmissionFees,
        fiveYrTsrySwap,
        tenYrTsrySwap,
        yieldSpread: newRate ? yieldSpreadPremium : 0,
        maxYieldSpread: newRate ? scenario.maxYspBasedonAmortizationType[amortization] : 0,
        pricerLoanTerms: {
          loanTerms: scenario.ltvRates,
          allInvestorRates: scenario.allInvestorRates,
          maxYspBasedonAmortizationType: scenario.maxYspBasedonAmortizationType,
          maxYsp: scenario.maxYspBasedonAmortizationType[amortization],
          overRideRates: scenario.overRideRatesBasedonAmortizationType,
        },
        addOnPoints: borrowerSubmissionFees.termOriginationPoints ?? 0,
        addOnPointsAmount: (borrowerSubmissionFees.termOriginationPoints ?? 0) / 100 * loanAmount,
      }

      if (yieldSpreadPremium > 0) {
        const yspData = {
          rates: newQuote.fullScenario.ltvRates,
          standardRates: null,
          yieldSpread: yieldSpreadPremium > newQuote.maxYieldSpread ? newQuote.maxYieldSpread : Number(yieldSpreadPremium.toFixed(4)),
          loanSubtype: request.loanSubtype,
          loanTerm: request.loanTerm,
          rateType: request.rateType,
          propertyType: request.propertyType,
          userId: request.userId,
          numberOfProperties: 1,
          noOfUnits: request.numberOfUnits,
          asIsValue: request.asIsValue,
          allInvestorRates: newQuote.fullScenario.allInvestorRates,
          allInvestorStandardRates: null,
          isBroker: false,
          monthlyRent: request.monthlyRent,
          grossAnnualTaxes: annualTaxes.value,
          grossAnnualInsurance: annualInsurance.value,
          annualHOADues: annualHOA.value,
          currentBuydown: 0,
          buydownPoints: 0,
          loanToValue: loanToValue,
          amortization: request.amortization,
          prePaymentPenalty: request.prePaymentPenalty,
          loanPurpose,
          ...underwritingProcessingFees,
        };

        const yspResponse: ApiResponse = yield this.loanSubmissionService.getSingleScenarioYieldSpread(yspData);
        const yieldScenario = yspResponse.data;
        const yspAmortizationData = yieldScenario.rates[rateType.value][amortization.value];
        const yspRateObj = yspAmortizationData.baseRates[ltvRange];
        const yspNewRate = yspRateObj.errorMessage.length === 0 ? this.calculateRate(yspRateObj) : null;

        const yspNewQuote = {
          ...newQuote,
          rate: yspNewRate,
          amortizationData,
          pricerLoanTerms: {
            ...newQuote.pricerLoanTerms,
            loanTerms: yieldScenario.rates,
          },
        }

        newQuote = yspNewQuote;
      }

      if (!isNil(newQuote.rate)) {
        const newLoanTerms = yield this.fetchSfrPricerLoanTermsValuesV2(newQuote, yieldSpreadPremium);

        newQuote.pricerLoanTerms = {
          ...newQuote.pricerLoanTerms,
          ...newLoanTerms,
        };
      }
      this.displayedQuotes[quoteIndex] = { ...newQuote, cashToClose: this.calculateCashToClose(newQuote, borrowerSubmissionFees), };
    } catch (error) {
      console.log('Error setting rates for custom quote', error);
    }
  }

  *getPrepayPenaltyOptions(request) {
    const response: ApiResponse = yield this.loanSubmissionService.getPrepayOptions(request);
    this.prepaymentPenaltyOptions = response?.data || prePaymentPenaltyOptionsNoPrepayOnly;
    this.loanEconomicsFormStore.onFieldChange('prepenaltyPayment', this.prepaymentPenaltyOptions[0].value);
  }

  removeDisplayedQuote(quote) {
    this.displayedQuotes = this.displayedQuotes.filter(
      (q) => q.buydownKey !== quote.buydownKey
    );
  }

  toggleCustomQuote(quote) {
    if (this.selectedQuotes.includes(quote)) {
      this.selectedQuotes = this.selectedQuotes.filter(q => q != quote);
    } else {
      this.selectedQuotes.push(quote);
    }
  }

  clearSelectedQuotes() {
    this.rateScenarios = [];
    this.selectedQuotes = [];
    this.displayedQuotes = [];
  }
}
